module.exports = __webpack_public_path__ + "img/2011.0.1.0_202310101542.jpg";